// BP 56 — inline SVG national flags for the language switcher.
//
// Why SVG and not emoji: regional-indicator flag emoji (🇬🇧 …) have NO glyphs on
// Windows/Chrome, so they fall back to the two-letter code ("GB") — which read
// as "missing flags" / "GB EN" in the switcher. Inline SVG renders identically
// on every OS. Each flag is drawn to a 3:2 viewBox and clipped to a rounded,
// hairline-bordered chip by the wrapper.

const FLAG_VIEWBOX: Record<string, string> = {
  en: '0 0 60 40',
  fr: '0 0 3 2',
  es: '0 0 3 2',
  da: '0 0 3 2',
  de: '0 0 3 2',
};

function FlagContent({ code }: { code: string }) {
  switch (code) {
    case 'en':
      return (
        <>
          <rect width="60" height="40" fill="#012169" />
          <path d="M0 0 60 40M60 0 0 40" stroke="#fff" strokeWidth="8" />
          <path d="M0 0 60 40M60 0 0 40" stroke="#cf142b" strokeWidth="3.5" />
          <path d="M30 0V40M0 20H60" stroke="#fff" strokeWidth="13" />
          <path d="M30 0V40M0 20H60" stroke="#cf142b" strokeWidth="7.5" />
        </>
      );
    case 'fr':
      return (
        <>
          <rect width="3" height="2" fill="#fff" />
          <rect width="1" height="2" fill="#002654" />
          <rect x="2" width="1" height="2" fill="#ce1126" />
        </>
      );
    case 'es':
      return (
        <>
          <rect width="3" height="2" fill="#c60b1e" />
          <rect y="0.5" width="3" height="1" fill="#ffc400" />
        </>
      );
    case 'de':
      return (
        <>
          <rect width="3" height="2" fill="#ffce00" />
          <rect width="3" height="1.333" fill="#dd0000" />
          <rect width="3" height="0.667" fill="#000" />
        </>
      );
    case 'da':
      return (
        <>
          <rect width="3" height="2" fill="#c8102e" />
          <rect x="0.95" width="0.35" height="2" fill="#fff" />
          <rect y="0.825" width="3" height="0.35" fill="#fff" />
        </>
      );
    default:
      return null;
  }
}

export function LocaleFlag({ code, size = 20 }: { code: string; size?: number }) {
  const h = Math.round((size * 2) / 3);
  // Unknown / pseudo-locale → a small globe glyph rather than a broken box.
  if (!FLAG_VIEWBOX[code]) {
    return (
      <span aria-hidden="true" style={{ fontSize: h, lineHeight: 1 }}>
        🌐
      </span>
    );
  }
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        width: size,
        height: h,
        borderRadius: 3,
        overflow: 'hidden',
        boxShadow: '0 0 0 1px rgba(0,0,0,0.12)',
        flex: 'none',
      }}
    >
      <svg width={size} height={h} viewBox={FLAG_VIEWBOX[code]} preserveAspectRatio="xMidYMid slice">
        <FlagContent code={code} />
      </svg>
    </span>
  );
}
